$(function(){
    if ( window.location !== window.parent.location ) {
        var headerLogo = document.querySelector('.header-logo');

        headerLogo.style.display = 'none';
        
        var css = '@media screen and (max-width: 1240px) { .navigation .menu { justify-content: center; }}',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');
    
        head.appendChild(style);
        
        style.type = 'text/css';
        if (style.styleSheet){
          // This is required for IE8 and below.
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
    }
});